<template>
  <v-dialog dark :value="showActiveAssetImg" @click:outside="closeDialog()">
    <v-card>
      <v-card-text
        class="pt-5 blue--text text--darken-1 text-center text-h6"
      >编码：{{ activeAssetImg.code }}</v-card-text>
      <div class="black pt-5 pb-5">
        <v-img v-if="showActiveAssetImg" contain height="250px" :src="activeAssetImg.src">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="shareImg">分享</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">关闭</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-overlay v-model="showWxShare" :opacity="0.9">
      <div class="share-img-box" @click="showWxShare = false">
        <div class="share-img-p">
          <img class="share-img" :src="require('../../assets/share_pointer.png')" />
          <div class="share-text text-center text--white text-h6">
            请点击右上角
            <br />将它发送给指定朋友
            <br />或分享到朋友圈
            <br />
            <v-btn class="primary mt-5">我知道了</v-btn>
          </div>
        </div>
      </div>
    </v-overlay>
  </v-dialog>
</template>
<script>
export default {
  name: 'DbAsAssetDialog',
  props: ['activeAssetImg', 'showActiveAssetImg'],
  data() {
    return {
      showWxShare: false
    }
  },
  watch: {
    showActiveAssetImg: function(newVal, oldVal) {
      // watch it
      if (newVal && !oldVal) {
        // eslint-disable-next-line
        const _this = this
        wx.ready(function() {
          const shareTitle = '发现一张精美汽车仪表盘壁纸'

          const shareDesc =
            '可直接显示在本田汽车仪表盘上，快来看看吧｜来自达芬奇汽车上传系统'
          const shareLink = `https://up.tssss.cn/imgu/dbas/ground/${_this.activeAssetImg.code}`
          const shareImgUrl = `${_this.activeAssetImg.src}`.replace(
            /style\/.*/,
            'style/wxpreview'
          )

          const shareConfig = {
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImgUrl
          }
          wx.updateAppMessageShareData(shareConfig)
          wx.updateTimelineShareData(shareConfig)
          wx.onMenuShareWeibo(shareConfig)
          wx.onMenuShareQZone(shareConfig)
          wx.onMenuShareTimeline(shareConfig)
          wx.onMenuShareAppMessage(shareConfig)
          wx.onMenuShareQQ(shareConfig)
          wx.onMenuShareQZone(shareConfig)
        })
      }
    }
  },

  methods: {
    closeDialog() {
      this.$emit('update', false)
    },
    shareImg() {
      this.showWxShare = true
    }
  }
}
</script>

<style scoped lang="scss">
.share-img-box {
  min-width: 100%;
  min-height: 100%;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .share-img {
    width: 350px;
  }
  .share-img-p {
    position: relative;
    height: auto;

    top: 10px;
    right: 10px;
    position: absolute;
    overflow: visible;
  }
  .share-text {
    bottom: 0;
    position: absolute;
    left: 50;
    transform: translate(-50%, 100%);
    white-space: nowrap;
  }
}
</style>
